import React from 'react'
import Pagination from '../../Hocs/Pagination'

import Page1 from './page1'
import Page2 from './page2'

export default Pagination({
  numberOfSlides: 2,
  renderItem: (props, index) => {
    if (index === 0) {
      return <Page1 {...props} active={props.currentPage === 0} />
    } else if (index === 1) {
      return <Page2 {...props} active={props.currentPage === 1} />
    }
  }
})
